/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './farmer-photo.scss';

/* eslint-disable import/no-unresolved, import/default */
import farmerPhotoTemplate from './farmer-photo.tpl.html';
/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.farmer.photo', [])
    .directive('farmerPhoto', farmerPhoto)
    .name;

/*@ngInject*/
function farmerPhoto() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '=',
            photo: "="
        },
        controller: FarmerPhotoController,
        controllerAs: 'vm',
        templateUrl: farmerPhotoTemplate
    };
}

function FarmerPhotoController($element, $scope, $window, Fullscreen) {
    let vm = this;

    vm.videoInput = [];
    vm.videoDevice = "";
    vm.previewPhoto = "";
    vm.isShowCamera = false;
    vm.isPreviewPhoto = false;

    let streamDevice = null;
    let indexWebCamera = 0;
    let videoElement = null;
    let canvas = null;
    let photoCamera = null;

    vm.getStream = getStream;
    vm.createPhoto = createPhoto;
    vm.takePhoto = takePhoto;
    vm.switchWebCamera = switchWebCamera;
    vm.cancelPhoto = cancelPhoto;
    vm.closeCamera = closeCamera;
    vm.savePhoto = savePhoto;
    vm.imageAdded = imageAdded;

    $scope.$watch('vm.ctx', () => {
        if (vm.ctx && hasGetUserMedia()) {
            vm.isCameraSupport = true;
            getDevices().then(gotDevices).then(() => {
                vm.isDeviceDetect = !!vm.videoInput.length;
            });
        }
    });

    function hasGetUserMedia() {
        return !!($window.navigator.mediaDevices && $window.navigator.mediaDevices.getUserMedia);
    }

    function takePhoto(){
        vm.isShowCamera = true;
        videoElement = $element[0].querySelector('#videoStream');
        photoCamera = $element[0].querySelector('#photoCamera');
        canvas = $element[0].querySelector('canvas');
        Fullscreen.enable(photoCamera);
        getStream();
    }

    function cancelPhoto() {
        vm.isPreviewPhoto = false;
        vm.previewPhoto = "";
    }

    function switchWebCamera() {
        indexWebCamera = (indexWebCamera+1)%vm.videoInput.length;
        vm.videoDevice = vm.videoInput[indexWebCamera].deviceId;
        getStream();
    }

    function getDevices() {
        return $window.navigator.mediaDevices.enumerateDevices();
    }

    function gotDevices(deviceInfos) {
        for (const deviceInfo of deviceInfos) {
            let device = {
                deviceId: deviceInfo.deviceId,
                label: ""
            };
            if (deviceInfo.kind === 'videoinput') {
                device.label = deviceInfo.label || `Camera ${vm.videoInput.length + 1}`;
                vm.videoInput.push(device);
            }
        }
    }

    function getStream() {
        if (streamDevice !== null) {
            streamDevice.getTracks().forEach(track => {
                track.stop();
            });
        }
        const constraints = {
            video: {deviceId: vm.videoDevice !== "" ? {exact: vm.videoDevice} : undefined}
        };
        return $window.navigator.mediaDevices.getUserMedia(constraints).then(gotStream);
    }

    function gotStream(stream) {
        streamDevice = stream;
        if(vm.videoDevice === ""){
            indexWebCamera = vm.videoInput.findIndex(option => option.label === stream.getVideoTracks()[0].label);
            indexWebCamera = indexWebCamera === -1 ? 0 : indexWebCamera;
            vm.videoDevice = vm.videoInput[indexWebCamera].deviceId;
        }
        videoElement.srcObject = stream;
    }

    function createPhoto() {
        canvas.width = videoElement.videoWidth;
        canvas.height = videoElement.videoHeight;
        canvas.getContext('2d').drawImage(videoElement, 0, 0);
        vm.previewPhoto = canvas.toDataURL('image/png');
        vm.isPreviewPhoto = true;
    }

    function closeCamera() {
        Fullscreen.cancel(photoCamera);
        vm.isShowCamera = false;
        if (streamDevice !== null) {
            streamDevice.getTracks().forEach(track => {
                track.stop();
            });
        }
        streamDevice = null;
        videoElement.srcObject = null;
    }

    function savePhoto() {
        vm.photo = vm.previewPhoto;
        vm.isPreviewPhoto = false;
        closeCamera();
    }

    function imageAdded($file) {
        let reader = new FileReader();
        reader.onload = (event) => {
            $scope.$apply(() => {
                if (event.target.result && event.target.result.startsWith('data:image/')) {
                    vm.photo = event.target.result;
                }
            });
        };
        reader.readAsDataURL($file.file);
    }
}

